"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenTransfersDataBuilder = void 0;
const argSerializer_1 = require("../smartcontracts/argSerializer");
const typesystem_1 = require("../smartcontracts/typesystem");
const tokens_1 = require("../tokens");
class TokenTransfersDataBuilder {
    constructor() {
        this.tokenComputer = new tokens_1.TokenComputer();
        this.argsSerializer = new argSerializer_1.ArgSerializer();
    }
    buildDataPartsForESDTTransfer(transfer) {
        const args = this.argsSerializer.valuesToStrings([
            new typesystem_1.TokenIdentifierValue(transfer.token.identifier),
            new typesystem_1.BigUIntValue(transfer.amount),
        ]);
        return ["ESDTTransfer", ...args];
    }
    buildDataPartsForSingleESDTNFTTransfer(transfer, receiver) {
        const token = transfer.token;
        const identifier = this.tokenComputer.extractIdentifierFromExtendedIdentifier(token.identifier);
        const args = this.argsSerializer.valuesToStrings([
            new typesystem_1.TokenIdentifierValue(identifier),
            new typesystem_1.BigUIntValue(token.nonce),
            new typesystem_1.BigUIntValue(transfer.amount),
            new typesystem_1.AddressValue(receiver),
        ]);
        return ["ESDTNFTTransfer", ...args];
    }
    buildDataPartsForMultiESDTNFTTransfer(receiver, transfers) {
        const argsTyped = [new typesystem_1.AddressValue(receiver), new typesystem_1.U32Value(transfers.length)];
        for (const transfer of transfers) {
            const identifier = this.tokenComputer.extractIdentifierFromExtendedIdentifier(transfer.token.identifier);
            argsTyped.push(...[
                new typesystem_1.TokenIdentifierValue(identifier),
                new typesystem_1.BigUIntValue(transfer.token.nonce),
                new typesystem_1.BigUIntValue(transfer.amount),
            ]);
        }
        const args = this.argsSerializer.valuesToStrings(argsTyped);
        return ["MultiESDTNFTTransfer", ...args];
    }
}
exports.TokenTransfersDataBuilder = TokenTransfersDataBuilder;
//# sourceMappingURL=tokenTransfersDataBuilder.js.map